import { Component, OnInit } from '@angular/core';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { SettingsManagementService } from '../../services/settings-management.service';
import { SettingFormJson, SettingsFormOptions, SettingsManagement } from 'src/app/core/Models/interfaces/settingFormJson';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from 'src/app/core/Models/interfaces/responseData';
import { SharedService } from 'src/app/shared/services/shared.service';
import { infoMsg } from 'src/app/core/Constants/static';

@Component({
  selector: 'app-settings-management',
  templateUrl: './settings-management.component.html',
  styleUrls: ['./settings-management.component.css']
})
export class SettingsManagementComponent implements OnInit {

  public JsonForm: SettingsManagement[] = [];
  public dynamicForm: FormGroup = new FormGroup({});
  private initFormValues: string = '';

  public isLoader: boolean = false;
  public submitted: boolean = false;
  public oneTimeShowFeildInfo: string = infoMsg.oneTimeShowFeildInfo;
  public forbidden:boolean=false;
  public forbidden_msg:string='';


  constructor(
    private formBuilder: FormBuilder,
    private generalSettingService: SettingsManagementService,
    private toasterandLoader: ToasterService,
    private http: HttpClient,
    private sharedService: SharedService
  ) { }

  public ngOnInit(): void {
    this.getSettingsManagementForm();
  }

  private getSettingsManagementForm(): void {
    this.toasterandLoader.isLoaderEnable(true);
    this.generalSettingService.getGeneralSettings().subscribe({
      next: (list) => {
        this.JsonForm = list.data;
        this.updateJsonItems();
        this.dynamicForm = this.buildForm(this.JsonForm);
        this.initFormValues = this.dynamicForm.value;
        this.toasterandLoader.isLoaderEnable(false);
      },
      error: (error) => {
        if(error.error_code!=54){
          this.toasterandLoader.alert.toast({
            title: 'Error',
            type: 'error',
            message: error.message
          })
        }
        else if(error.error_code==54){
          this.forbidden=true;
          this.forbidden_msg = error.message
        }
        this.toasterandLoader.isLoaderEnable(false);
      },
    });
  }

  private buildForm(data: SettingsManagement[]): FormGroup {
    let fGroup = this.formBuilder.group({});
    try {
      if (data) {
        data.forEach((genItem: SettingsManagement) => {
          genItem.general_setting.forEach((control: SettingFormJson) => {
            if (control.showInDisplay != 0) {
              const validators = this.getValidators(control);
              fGroup.addControl(control.metaKey, new FormControl(null, validators));
              this.setDefaultValue(fGroup, control);
            }
          });
        })

      }
    } catch (error) {
    }
    return fGroup;
  }

  private setDefaultValue(fGroup: FormGroup, control: SettingFormJson): void {
    let selectedValue: string | SettingsFormOptions | SettingsFormOptions[] = '';
    if (control.inputType?.toUpperCase() === 'TEXT' && control.metaValue) {
      selectedValue = control.metaValue;
    }
    else if (control.inputType?.toUpperCase() === 'RADIO' && control.metaValue) {
      control.options.forEach((opt) => {
        if (opt.value === control.metaValue) {
          selectedValue = opt.value;
        }
      });
    }
    else if (control.inputType.toUpperCase() === 'DROP_DOWN' && control.metaValue) {
      const prefillItems: string[] = control.metaValue.split(',');
      const seletedItems: SettingsFormOptions[] = [];
      if (control.options?.length) {
        prefillItems.forEach(ele => {
          const selectedItem = control.options.find(opt => ele?.toUpperCase() === opt.value?.toUpperCase());
          if (selectedItem) {
            seletedItems.push(selectedItem);
          }
        });
        if (prefillItems.length > 1) {
          selectedValue = seletedItems;
        }
        else {
          selectedValue = seletedItems[0];
        }
      }

    }
    fGroup.controls[control.metaKey]?.setValue(selectedValue);
  }

  private getValidators(validators: SettingFormJson): ValidationErrors {
    const formValidators = [];
    if (validators?.requiredField) {
      formValidators.push(Validators.required);
    }
    if (validators?.regularExpression) {
      formValidators.push(Validators.pattern(validators.regularExpression));
    }
    return formValidators;
  }

  private updateJsonItems(): void {
    this.JsonForm.sort((a, b) => a.displayOrder - b.displayOrder);
    this.JsonForm.forEach((genItem: SettingsManagement) => {
      genItem.general_setting.forEach(setttings => {
        if (setttings.dependentMetaKey && setttings.dependentMetaKey !== null) {
          genItem.general_setting.forEach(subItem => {
            if ((subItem.metaKey === setttings.dependentMetaKey) && (setttings.displayOrder != subItem.displayOrder)) {
              setttings.displayOrder = subItem.displayOrder;
            }
          });
          setttings.displayOrder = +(setttings.displayOrder + '.' + setttings.dependentMetaKeyOrder);
        }
        if (setttings.callBackUrl && setttings.callBackUrl !== null) {
          this.updateOptions(setttings);
        }
      });
      genItem.general_setting.sort((a, b) => a.displayOrder - b.displayOrder);
    });
  }

  private saveSettingsConfiugration(): void {
    this.isLoader = true;
    if (this.dynamicForm.valid) {
      let payload = this.dynamicForm.value;
      this.toasterandLoader.isLoaderEnable(true);
      this.generalSettingService.setGeneralSettings(payload).subscribe({
        next: (res) => {
          if (res.status == 'Success') {
            this.toasterandLoader.alert.toast({
              title: 'Success',
              type: 'success',
              message: res.message
            });
            this.JsonForm = <SettingsManagement[]>res.data;
            this.updateJsonItems();
            this.dynamicForm = this.buildForm(this.JsonForm);
            this.initFormValues = this.dynamicForm.value;
          } else {
            this.toasterandLoader.alert.toast({
              title: 'Error',
              type: 'error',
              message: res?.message
            })
          }
          this.toasterandLoader.isLoaderEnable(false);
          this.isLoader = false;
        },
        error: (error) => {
          this.toasterandLoader.alert.toast({
            title: 'Error',
            type: 'error',
            message: 'Something went Wrong !'
          })
          this.toasterandLoader.isLoaderEnable(false);
          this.isLoader = false;
          this.submitted = false;
        }
      })
    }
  }

  private updateOptions(genItem: SettingFormJson): void {
    this.toasterandLoader.isLoaderEnable(true);
    if (genItem.callBackUrl && genItem.showInDisplay != 0) {
      this.http.get<ApiResponse>(genItem.callBackUrl).subscribe({
        next: (list) => {
          genItem.options = list.data;
          this.setDefaultValue(this.dynamicForm, genItem);
          this.initFormValues = this.dynamicForm.value;

        },
        error: (error) => {
        },
      });
    }
  }

  public confirmUpdate(): void {
    this.submitted = true;
    if (this.dynamicForm.valid) {
      this.toasterandLoader.alert.confirm(
        {
          text: `changes made will be updated. Do you wish to proceed?`,
          type: 'warning',
          hideCancelButton: false,
          okText: 'Yes',
          cancelText: 'No',
          title: 'Are you sure?',
        }
      ).then((res) => {
        if (res) {
          this.saveSettingsConfiugration();
        };
      });
    }
    else {
      this.sharedService?.scrollToFirstInvalidControl();
    }

  }

  public resetForm(): void {
    if (JSON.stringify(this.initFormValues) !== JSON.stringify(this.dynamicForm.value)) {
      this.toasterandLoader.alert.confirm({
        text: `All the changes made will be lost. Do you wish to proceed?`,
        type: 'warning',
        hideCancelButton: false,
        okText: 'Yes',
        cancelText: 'No',
        title: 'Are you sure?',
      }).then((res) => {
        if (res) {
          this.isLoader = false;
          this.dynamicForm.reset();
          this.getSettingsManagementForm();
        };
      });
    }
    else {
      this.toasterandLoader.alert.toast({
        title: 'Warning',
        type: 'warning',
        message: 'Nothing is changed to reset the form.'
      });
    }
  }
}
